module.exports = __webpack_public_path__ + "img/high-4.06f1daf9.svg";